"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TimelineMonthLabel;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _misc = require("HubStyleTokens/misc");

var _sizes = require("HubStyleTokens/sizes");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-family: ", ";\n  font-size: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledMonthLabelDiv = _styledComponents.default.div.withConfig({
  displayName: "TimelineMonthLabel__StyledMonthLabelDiv",
  componentId: "sc-1pv1ykw-0"
})(_templateObject(), _misc.WEB_FONT_REGULAR, _sizes.FORM_COPY_SIZE);

function TimelineMonthLabel(_ref) {
  var children = _ref.children,
      className = _ref.className;
  var labelClasses = (0, _classnames.default)(className, 'm-left-1');
  return _react.default.createElement(StyledMonthLabelDiv, {
    className: labelClasses
  }, children);
}

TimelineMonthLabel.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string
};
module.exports = exports.default;